export type ConfiguratorPage = 'choose-language' 
                             | 'choose-category'
                             | 'choose-family'
                             | 'choose-variant' 
                             | 'choose-subfamily' 
                             | 'cart3d' 
                             | 'configurator'
                             ;

export const URLS = {
    root: '/',
    home: '/:langId',
    cart3d: '/:langId/cart-3d/:cartId',
    category: '/:langId/:categoryId',
    family: '/:langId/:categoryId/:familyId',
    subFamily: '/:langId/:categoryId/subf/:subFamilyId',
    familyCfg: '/:langId/:categoryId/:familyId/configurator',
    variantCfg: '/:langId/:categoryId/:familyId/:variantId/configurator'
}

export const urls = {
    home: (langId: string, params?: {
        cartCode?: string
        language?: string
    }) => {
        if(params) {
            const searchParams = new URLSearchParams();
            if(params.cartCode) {
                searchParams.append('SC',params.cartCode);
            }
            if(params.language) {
                searchParams.append('L', params.language);
            }
            return `/${langId}?${searchParams.toString()}`;
        } else {
            return `/${langId}`;
        }
        
    },
    cart3d: (langId: string, cartId: number) => {
        return `/${langId}/cart-3d/${cartId}`;
    },
    category: (langId: string, categoryId: string) => {
        return `/${langId}/${categoryId}`;
    },
    family: (langId: string, categoryId: string, familyId: string) => {
        return `/${langId}/${categoryId}/${familyId}`;
    },
    subFamily: (langId: string, categoryId: string, familyId: string) => {
        return `/${langId}/${categoryId}/subf/${familyId}`;
    },
    familyCfg: (langId: string, categoryId: string, familyId: string) => {
        return `/${langId}/${categoryId}/${familyId}/configurator`;
    },
    variantCfg: (langId: string, categoryId: string, familyId: string, variantId: string) => {
        return `/${langId}/${categoryId}/${familyId}/${variantId}/configurator`;
    }
}

export const SUMMARY_STAGE = '*SUMMARY';
export const COMPOSE_STAGE = '*COMPOSE';